export const customerStatusColor = {
  INACTIVE: "gray",
  PENDING: "orange",
  COMPLETE: "green",
  ERROR: "red",
  REJECTED: "red",
} as const;
